<template>
  <div ref="imgContent" style="width: 100%">
    <vue-drag-resize :h="46"
                     :isResizable="false"
                     :key="item.id"
                     :parentH="imgHeight"
                     :parentW="imgWidth"
                     :isDraggable="edit"
                     :w="34"
                     :x="item.xoffset.length > 1 ?   item.xoffset*imgWidth/100-17:Number.parseFloat(item.xoffset)*imgWidth/initWidth-17"
                     :y="item.yoffset.length > 1 ?  item.yoffset*imgHeight/100-46:Number.parseFloat(item.yoffset)*imgHeight/initHeight-46"
                     @dragstop="(point) => {return stopDrag(point,item)}"
                     style="z-index: 99;cursor:pointer;"
                     v-for="item in boundDeviceList">
      <img :height="46"
           :src="item.status==0?'/static/images/menus/areaIcon.png':'/static/images/menus/areaAlarmIcon.png'"
           :title="item.cnName"
           :width="34" style="float: left;z-index: 999">
      <div class="name" :style="{backgroundColor: item.status == 0 ? 'rgba(0,111,255,0.5)' : 'rgba(249, 88, 87, 0.5)'}">
        <div class="deviceName" :style="{backgroundColor:item.status == 0 ? 'rgba(0,111,255,0.5)' : 'rgba(249, 88, 87, 0.5)'}">
          <i @touchstart="delDevice(item)" @click="delDevice(item)"
             class="el-icon-close close-btn float-right pointer"
             style="margin-right: -18px;margin-top: 2px;"></i>
          {{ item.cnName }}
        </div>
      </div>
    </vue-drag-resize>
    <!--      背景图-->
    <img
      :src="selectTier===undefined || selectTier===null || selectTier.bgImage===null ||selectTier.bgImage==='' ? require('@/assets/images/no-bg.png') : $ftpUrl + selectTier.bgImage"
      alt=""
      @load="this.resizeDrawSlackLineContainer"
      class="bg-img"
      height="100%"
      ref="spaceBackgroundImage"
      width="100%"
    >
  </div>
</template>

<script>
import VueDragResize from 'vue-drag-resize';
import {updatePointList} from "@/network/device-measuring-point";
import {saveAreaInfo} from "@/network/fire-alarm-panel-network";

export default {
  name: "EditIndoorSettingDevice",
  components: {VueDragResize},
  props: {
    selectTier: {
      type: Object
    },
    spaceId: {
      type: String,
      default: () => '0'
    },
  },
  data() {
    return {
      spaceInfo: {},
      boundDeviceList: [], //已绑的设备
      unBoundDeviceList: [], //未绑的设备
      slackLineDeviceList: [], //已绑的漏水设备
      edit: true,
      imgWidth: 0,
      imgHeight: 0,
      initWidth: 0,
      initHeight: 0,
      flag: false, //是否画线
      x: [],
      y: [],
      title: '测点编辑',
      dialogWidth: '45vw',
      operate: 'point',
      pointList: [],
      checkPointIds: [],
      // 过滤绑定和未绑定定时器
      filterWhetherBindTimer: null,
    }
  },
  mounted() {
    // 重新过滤绑定和未绑定
    this.filterWhetherBindTimer = setInterval(() => {
      this.filterWhetherBind()
    }, 3000)
    window.onresize = () => {
      return (() => {
        this.resizeDrawSlackLineContainer()
      })();
    };
  },
  destroyed() {
    clearInterval(this.filterWhetherBindTimer);
    this.filterWhetherBindTimer = null;
    window.onresize=null
  },
  methods: {
    // 筛选绑定和未绑定设备
    filterWhetherBind() {
      let unBoundDeviceListCopy = []
      let boundDeviceListCopy = []
      this.selectTier.children.forEach(info => {
          if (info.xoffset == null && info.yoffset == null) {
            unBoundDeviceListCopy.push(info)
          }
        }
      )
      this.selectTier.children.forEach(info => {
          if (info.xoffset || info.yoffset) {
            boundDeviceListCopy.push(info)
          }
        }
      )
      this.unBoundDeviceList = unBoundDeviceListCopy
      this.boundDeviceList = boundDeviceListCopy
      this.$emit("getUnboundDeviceList", this.unBoundDeviceList)
    },
    // 分辨率改变重置内景图坐标
    resizeDrawSlackLineContainer() {
      this.imgHeight = this.$refs.spaceBackgroundImage.height
      this.imgWidth = this.$refs.spaceBackgroundImage.width
      this.initHeight = this.$refs.spaceBackgroundImage.height
      this.initWidth = this.$refs.spaceBackgroundImage.width
      this.$emit("changeIndoorLoaded", true)
    },
    //停止拖拽
    stopDrag(point, item) {
      console.log("1", point, item);
      console.log("2", this.imgWidth, this.imgHeight)
      const initX = 17 * 100 / this.imgWidth;
      const initY = 46 * 100 / this.imgHeight;
      if (point) {
        item.xoffset = point.left > -16 ? ((point.left + 17) * 100 / this.imgWidth).toString() : initX.toString();
        item.yoffset = point.top > -46 ? ((point.top + 46) * 100 / this.imgHeight).toString() : initY.toString();
      } else {
        item.xoffset = initX;
        item.yoffset = initY;
      }
      this.saveAreaInfo(item);
    },
    // 保存坐标
    saveAreaInfo(item, delFlag) {
      let areaInfo = {
        "id": "",
        "bgImage": "",
        "xoffset": "",
        "yoffset": ""
      }
      areaInfo.id = item.id;
      areaInfo.xoffset = item.xoffset;
      areaInfo.yoffset = item.yoffset;
      console.log("保存后设备信息", areaInfo)
      saveAreaInfo(areaInfo).then(res => {
        if (res.code == 0) {
          this.$emit("updateIndoorInfo")
          if (delFlag) {
            this.$message.success(item.cnName + "删除成功!")
          }
        } else {
          if (delFlag) {
            this.$message.success(item.cnName + "删除失败!")
          }
        }
      })
    },
    delDevice(item) {
      console.log(item, "-click");
      this.$confirm('是否确认删除' + item.cnName, {
        cancelButtonText: '取消',
        confirmButtonText: '确定',
        callback: action => {
          if (action === 'confirm') {
            item.xoffset = null
            item.yoffset = null
            this.saveAreaInfo(item, true)
          }
        }
      })
    },
    //获取勾选的测点id
    setCheckPoint(data) {
      this.checkPointIds = data
    },
    preservation() {
      const result = this.pointList.map(item => {
        item.spaceShow = this.checkPointIds.indexOf(item.id) > -1;
        return item
      })
      updatePointList(result).then(res => {
        if (res.code === 0) {
          this.$message.success("保存成功!")
        } else {
          this.$message.error("保存失败!")
        }
        this.dialogVisible = false;
      })
    },
  }
}
</script>

<style scoped>
.name {
  background-color: rgba(0, 111, 255, 0.5);
  color: #fff;
  font-size: 0.8rem;
  margin-left: 15px;
  line-height: 28px;
  margin-top: 16px;
  white-space: nowrap;
}

.name .deviceName {
  display: inline-block;
  background-color: rgba(0, 111, 255, 0.5);
  padding-right: 22px;
  border-bottom-right-radius: 4px;
  border-top-right-radius: 4px;
}
</style>
